import { render, staticRenderFns } from "./UserRegistration.vue?vue&type=template&id=5586a2b4&"
import script from "./UserRegistration.vue?vue&type=script&lang=js&"
export * from "./UserRegistration.vue?vue&type=script&lang=js&"
import style0 from "./UserRegistration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports